import icon from './images/open_close_icon.png'

export const Section4IconComponent = () => {
    return (
        <img src={icon} alt="Abrir/Cerrar" />
    )
}